import { useEffect, useCallback } from "react";
import { useNavigate, withRouter } from "react-router";
import logo from "../../../../assets/images/logo.png";
const RazorpayOverlay = ({ history, user, onClose ,amount}) => {
  //console.log("amount",amount);
  
  const navigate = useNavigate();
  const paymentHandler = async (response) => {
    
    // navigate("/checkout");
     navigate(`/checkout?payment_id=${response.razorpay_payment_id}`);
    onClose?.();
  };

  const initializeRazorPay = useCallback((user) => {
    const { session } = JSON.parse(localStorage.getItem("ck_session"));
    //console.log("s",session);
    if (!session) {
      alert("Session not found.");
      onClose?.();
      return;
    }
    // Defensive: Don't open Razorpay if session/order_id is not valid
    if (!session || session === "FREE_COURSES_CHECKOUT") {
      alert("Invalid session. Please try again.");
      onClose?.();
      return;
    }
    const razorPayment = new window.Razorpay({
      key: `${process.env.REACT_APP_RAZOR_PAY_KEY}`,
      currency: "INR",
      name: "yslearn",
      amount: amount,
      description: `Payment of ₹${amount}`,
      order_id: session,
      image: logo,
      theme: {
        color: "#264b82",
      },
      // handler: paymentHandler,
      handler: (response) => paymentHandler(response),
      modal: {
        ondismiss: () => {
          onClose?.()
        },
      },
      prefill: {
        name: user.name,
        email: user.email,
        contact: user.phoneNumber,
      },
    });
    razorPayment.open();
  }, [onClose, user,amount]);

useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  script.onload = () => initializeRazorPay(user);
  document.body.appendChild(script);
  return () => {
    document.body.removeChild(script);
  };
}, [initializeRazorPay]);
return null;
};

export default RazorpayOverlay;


